/**
 * @generated SignedSource<<568992b127e8cdcb2654e2b5341f489d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SalesChannelStatus = "ACTIVE" | "DISABLED";
export type salesChannelSetStatusMutation$variables = {
  id: string;
  status: SalesChannelStatus;
};
export type salesChannelSetStatusMutation$data = {
  readonly setSalesChannelStatus: {
    readonly taskID: number | null;
  };
};
export type salesChannelSetStatusMutation = {
  response: salesChannelSetStatusMutation$data;
  variables: salesChannelSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "SetSalesChannelStatusOutput",
    "kind": "LinkedField",
    "name": "setSalesChannelStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSetStatusMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSetStatusMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "0e2d84edb3633fda894b7b695e9e18b5",
    "id": null,
    "metadata": {},
    "name": "salesChannelSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSetStatusMutation(\n  $id: ID!\n  $status: SalesChannelStatus!\n) {\n  setSalesChannelStatus(id: $id, status: $status) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "58ded33268b00fbf12ffe3ac70d2d694";

export default node;
